@if (selectionVisible()) {
  <div @mobileSelectionAnimation class="mobile-selection-header">
    <mat-checkbox (change)="selectAll.emit($event.checked)" [checked]="allItemsChecked()">
      <mat-label>Alle auswählen</mat-label>
    </mat-checkbox>

    <button class="toggle-button" (click)="closeSelection.emit()">
      <ui-icon faName="times" faStyle="light"></ui-icon>
    </button>
  </div>
}

<div [class.selection-invisible]="!selectionVisible()" class="content-wrapper">
  <ng-content></ng-content>
</div>